<template>
  <div class="task-question">
    <header class="task-question__header">
      <span class="invalid" v-if="invalid">*</span>
      {{ questionItem.question }}
    </header>
    <div class="task-question__radio-wrapper">
      <RadioButton
        :name="`group-${questionItem.question}`"
        :value="true"
        :checked="questionItem.answer == true"
        @change="handleChange"
        label="Yes"
        :disabled="disableSelection"
      />
      <RadioButton
        :name="`group-${questionItem.question}`"
        :value="false"
        :checked="questionItem.answer == false"
        @change="handleChange"
        label="No"
        :disabled="disableSelection"
      />
      <RadioButton
        :name="`group-${questionItem.question}`"
        :value="null"
        :checked="questionItem.answer === null"
        @change="handleChange"
        label="N/A"
        :disabled="disableSelection"
      />
    </div>

    <div v-if="questionItem.answer">
      <p class="task-question__issues">Were there any issues?</p>
      <div class="task-question__radio-wrapper">
        <RadioButton
          :name="`issues-rb-${questionItem.question}`"
          :value="true"
          :checked="item.haveIssues == true"
          @change="(e: RadioButtonChangeEvent) => (item.haveIssues = e.value)"
          label="Yes"
          :disabled="disableSelection"
          data-cy="issues-rb"
        />
        <RadioButton
          :name="`issues-rb-${questionItem.question}`"
          :value="false"
          :checked="item.haveIssues == false"
          @change="(e: RadioButtonChangeEvent) => (item.haveIssues = e.value)"
          label="No"
          :disabled="disableSelection"
          data-cy="issues-rb"
        />
      </div>
    </div>

    <InspectionCommentsView :comments="item.savedComments ?? []" />
    <textarea
      v-model="item.comments"
      class="task-question__textarea"
      :rows="1"
      :cols="20"
      :maxlength="5000"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { TaskQuestionItem } from "@/Domain/TaskQuestionItem";
import type { RadioButtonChangeEvent } from "@progress/kendo-vue-inputs";
import RadioButton from "@/shared/ui/inputs/RadioButton.vue";
import InspectionCommentsView from "./InspectionCommentsView.vue";

const props = defineProps<{
  questionItem: TaskQuestionItem;
  disableSelection: boolean;
  invalid: boolean;
}>();

const item = computed(() => props.questionItem);

const handleChange = function (e: RadioButtonChangeEvent) {
  item.value.answer = e.value;
};
</script>

<style scoped lang="scss">
.task-question {
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  &__header {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;

    .invalid {
      color: red;
      font-size: 18px;
    }
  }

  &__issues {
    font-size: 14px;
    margin-bottom: 8px;
  }

  &__radio-wrapper {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }

  &__checkbox {
    margin-bottom: 10px;
  }

  &__textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    resize: vertical;
    min-height: unset;
  }
}
</style>
